<template>
    <div v-if="products" id="last-seen" :class="extraClass">
        <div class="row">
            <div class="last-seen">
                <div class="last-seen--title">
                    <h3>Naposledy ste si pozreli:</h3>
                </div>
    
                <div class="last-seen--list">
                    <a 
                        :href="product.url" 
                        class="last-seen--list--item" 
                        v-for="(product, key) in products" 
                        :key="key" 
                        @click="trackProductClick(product, 'Naposledy ste si pozreli', key + 1)"
                    >
                        <ProductImage :product="product" singleClass="product-image-small" bundleClass="medium-bundle-image" />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ProductImage from '../product/ProductImage'

    export default {
        components: {
            ProductImage
        },
        props: {
            extraClass: {
                type: String
            }
        },
        data() {
            return {
                errors: null,
                productIds: [],
                products: null
            }
        },
        created() {
            this.loadData()
        },
        methods: {
            loadData() {
                this.productIds = JSON.parse(localStorage.getItem("lastSeenProducts") || "[]")

                axios.post('/api/shop/product/last-seen', {products: this.productIds})
                .then( response => { this.products = response.data.products })
                .catch( errors => { this.errors = errors.response.data.errors })
            },
            trackProductClick(product, list, position) {
                // Call the tracking function for product click
                if (window.AnalyticScripts && window.AnalyticScripts.trackProductClick) {
                    window.AnalyticScripts.trackProductClick(product, list, position);
                } else {
                    console.error('Tracking script not loaded');
                }
            }
        },
    }
</script>